/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 94b71f76493f6c5beb5c58c46e067d7971541124abdf38ecc8cc66f77eefc233
 */
import {
  base_colorContentBorder,
} from 'ext-ui/style/colors'
import { css } from 'styled-components'

export default css`
  border-top-color: ${base_colorContentBorder};
  border-top-style: solid;
  border-top-width: 1px;
  margin: 0;
  width: 100%;
`
